import axios from 'axios';
import customAxios from '../../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../../scss/Components/_modal.scss"
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../../globalVar';
import { getToast } from '../../../../utils/toastConfig';

function ModalQMultDelete(props) {
    let idList = []
    let deleteList = localStorage.getItem("qMultipleDeleteList");
    if (deleteList !== null && deleteList !== undefined) {
        idList = deleteList.replace(/\[|\]|\'/g, '').split(',').map(Number);
    }

    function deleteQuestions() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}multipleDeleteQuestions`,
            method: 'delete',
            data: {
                'idList': idList,
                'section_id': props.selectedSection
            },
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then(response => {
            console.log(response.data);
            hideS();
        }).catch(error => {
            console.error(error);
            getToast({ status: 'error', title: 'Error al eliminar pregunta(s). Vuelve a intentarlo.' });
        });
    }   
    
    function hideS() {
        props.onHide();
        getToast({ status: 'success', title: 'Pregunta(s) eliminada exitosamente en el cuestionario.' });
        props.getQuestionsData(props.selectedSection);
    }  

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    ¿Quieres borrar estas preguntas?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {idList.map(id => <span><strong>ID de la pregunta:</strong> {id}<br/></span>)}
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteQuestions()}}><FontAwesomeIcon icon={faWarning}/> Si, quiero eliminar esto.</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> No, regrésame a la tabla.</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalQMultDelete;